import {
  UPDATE_APPS,
  UPDATE_APP_USERS,
  REMOVE_ROLES,
  ADD_ROLES,
  UPDATE_FOUND_USERS,
  ADD_USER_TO_APP,
  REMOVE_USER_FROM_APP,
  REMOVE_FOUND_USER,
  SET_ADMIN_DATA,
  SET_USER_RT_MUTATION,
} from '../constants';

export default {
  [UPDATE_APP_USERS](state, { appName, users }) {
    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.users = users;
      }
      return app;
    });
  },

  [SET_USER_RT_MUTATION](state, isSend) {
    state.isSendRefreshToken = isSend;
  },

  [REMOVE_ROLES](state, { sub, roles, appName }) {
    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.users = app.users.map((user) => {
          if ((+user.sub || +user.integerId) === +sub) {
            user.roles[appName] = user.roles[appName].filter(r => !roles.includes(r));
          }
          return user;
        });
      }
      return app;
    });
  },

  [ADD_ROLES](state, { sub, roles, appName }) {
    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.users = app.users.map((user) => {
          if ((+user.sub || +user.integerId) === +sub) {
            if (!user.roles) user.roles = {};
            if (!user.roles[appName]) user.roles[appName] = [];
            user.roles[appName] = [...user.roles[appName], ...roles];
          }
          return user;
        });
      }
      return app;
    });
  },

  [UPDATE_APPS](state, payload) {
    state.apps = payload.map((newApp) => {
      newApp.users = [];
      newApp.foundUsers = [];
      return newApp;
    });
  },

  [UPDATE_FOUND_USERS](state, { foundUsers, appName }) {
    const currentAppUsers = state.apps.find(app => app.name === appName).users;
    const currentAppUsersIds = currentAppUsers.map(user => user.sub || user.integerId);

    const newFoundUsers = foundUsers.filter(
      user => currentAppUsersIds.indexOf(user.sub || user.integerId) < 0,
    );

    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.foundUsers = newFoundUsers;
      }
      return app;
    });
  },

  [ADD_USER_TO_APP](state, { user, appName }) {
    if (!user.roles) {
      user.roles = {};
    }
    if (!user.roles[appName]) {
      user.roles[appName] = [];
    }

    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.users = [...app.users, user];

        const newFoundUsers = [...app.foundUsers];
        const results = [];

        newFoundUsers.forEach((item) => {
          if ((item.sub || item.integerId) !== (user.sub || user.integerId)) {
            results.push(item);
          }
        });
        app.foundUsers = results;
      }
      return app;
    });
  },

  [REMOVE_USER_FROM_APP](state, { userId, appName }) {
    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.users = app.users.filter(user => (+user.sub || +user.integerId) !== +userId);
      }
      return app;
    });
  },

  [REMOVE_FOUND_USER](state, { userId, appName }) {
    state.apps = state.apps.map((app) => {
      if (app.name === appName) {
        app.foundUsers = app.foundUsers.filter(user => (+user.sub || +user.integerId) !== +userId);
      }
      return app;
    });
  },

  [SET_ADMIN_DATA](state, { user }) {
    state.user = user;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js